import React from "react";
import AnimatedContainer from "./AnimatedContainer";
import Card from "./Card";

function Beneficios (){
    const imageUrl='https://raw.githubusercontent.com/LTuhay/rosa-recicla/master/public/assets/benefit.jpg';
    const text='El reciclaje tiene beneficios y ventajas que se pueden agrupar en los siguientes puntos:<ul><li>Preservación de los recursos naturales.</li><li>Disminución de la contaminación.</li><li>Ahorro de energía.</li><li>Ahorro de dinero.</li><li>Ahorro de petróleo.</li></ul>'
    const additionalText='<p>Todos estos beneficios se pueden ejemplificar con datos concretos que son más impactantes que las palabras abstractas.</p><p>Ocho cajas de cereales se pueden convertir en un libro. Fabricar una lata gasta un 95% más de energía que reciclarla. Ochenta latas de gaseosas recicladas se pueden convertir en una llanta.</p>';
    return (
        <div>
            <AnimatedContainer animationDuration="2s">
                <Card image={imageUrl} title='Beneficios y ventajas' text={text} additionalText={additionalText} imagePosition='left' />
            </AnimatedContainer>
        </div>
    )
}

export default Beneficios;